export function isBrowser() {
  return typeof window !== 'undefined';
}

export function isChrome() {
  // Chrome 1+
  // @ts-expect-error TS(2339): Property 'chrome' does not exist on type 'Window &... Remove this comment to see the full error message
  return isBrowser() && Boolean(window.chrome);
}

export function setScrollRestorationManual() {
  // https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
  if ('scrollRestoration' in window.history) {
    // Try / catch for scrollRestoration writable: https://github.com/taion/scroll-behavior/issues/126
    try {
      // Back off, browser, I got this...
      window.history.scrollRestoration = 'manual';
    } catch (e) {
      /* silence */
    }
  }
}
